import { lazy, useContext } from 'react';

import { LayoutHeaderDefaultSearchTypeContext } from '#/layouts/Layout/Header/LayoutHeaderDefaultSearchTypeContext';

import type { SearchRefinementsLayout } from './SearchRefinements';

const LazySearchEventsRefinements = lazy(() =>
  import('#/modules/search/events/components/Refinements/SearchEventsRefinements').then(
    (m) => ({ default: m.SearchEventsRefinements }),
  ),
);

const LazySearchInternshipRefinements = lazy(() =>
  import('#/modules/search/internships/components/Refinements/SearchInternshipRefinements').then(
    (m) => ({ default: m.SearchInternshipRefinements }),
  ),
);

const LazySearchJobsRefinements = lazy(() =>
  import('#/modules/search/jobs/components/Refinements/SearchJobsRefinements').then(
    (m) => ({ default: m.SearchJobsRefinements }),
  ),
);

const LazySearchOrgsRefinements = lazy(() =>
  import('#/modules/search/orgs/components/Refinements/SearchOrgsRefinements').then(
    (m) => ({ default: m.SearchOrgsRefinements }),
  ),
);

const LazySearchVolopsRefinements = lazy(() =>
  import('#/modules/search/volops/components/Refinements/SearchVolopsRefinements').then(
    (m) => ({ default: m.SearchVolopsRefinements }),
  ),
);

type Args = {
  variant?: SearchRefinementsLayout;
};

/**
 * Ideally we should get rid of this component and reference the refinements
 * we need directly, but we need it in the SearchLandingPage
 */
export function SearchRefinementsSwitch({ variant }: Args) {
  const searchType = useContext(LayoutHeaderDefaultSearchTypeContext);

  switch (searchType) {
    case 'JOB':
      return <LazySearchJobsRefinements layoutVariant={variant} />;
    case 'INTERNSHIP':
      return <LazySearchInternshipRefinements layoutVariant={variant} />;
    case 'VOLOP':
      return (
        <LazySearchVolopsRefinements
          includeSourcesFacet={false}
          layoutVariant={variant}
        />
      );
    case 'ORG':
      return <LazySearchOrgsRefinements layoutVariant={variant} />;
    case 'EVENT':
      return <LazySearchEventsRefinements layoutVariant={variant} />;
  }
}
